import { BlockedCustomer } from 'types';

import { createCrudApi } from './crud.api';

export const blockedCustomersApi =
  createCrudApi<BlockedCustomer>('/blocked-customers');
